import { Button } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { getIcon } from 'app/components/ErplyIcon';

interface Props {
  children?: never;
  handlePrevStep: () => void;
}

const StyledButton = styled(Button)`
  margin-top: 0.6rem;
  text-transform: capitalize;

  ::before {
    font-family: Erply-Icons, serif;
    content: '${getIcon('Chevron-Left-Small')}';
    font-size: 1.6rem;
  }
`;

const PrevStep: React.FC<Props> = ({ handlePrevStep }) => {
  const { t } = useTranslation();
  return (
    <StyledButton onClick={handlePrevStep} tabIndex={-1}>
      {t('registration.back')}
    </StyledButton>
  );
};

export default PrevStep;
